import type { CheckoutStep } from '../hooks/useProceedToCheckoutStep';

/**
 * Helper function to determine the appropriate checkout step based on
 * current page, feature flags, and user login status
 *
 * @param featureFlags Feature flags that determine which step to proceed to
 * @returns The appropriate checkout step
 */

export type CheckoutFeatureFlags = {
  insuranceEnabled: boolean;
};

export const determineCheckoutStep = ({
  currentPage,
  featureFlags,
  userIsLoggedIn,
}: {
  featureFlags: CheckoutFeatureFlags;
  currentPage: CheckoutStep;
  userIsLoggedIn: boolean;
}): CheckoutStep => {
  const { insuranceEnabled } = featureFlags;
  switch (currentPage) {
    case 'book-now':
      return userIsLoggedIn ? 'add-ons' : 'register';

    case 'add-ons':
      if (insuranceEnabled) return 'insurance';
      return 'payment';

    case 'register':
      return 'add-ons';

    case 'insurance':
    default:
      return 'payment';
  }
};
